import { type NextBestAction } from '@post-office/confluence-next-best-action';
import { defaultMessageBackend } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';

// assertMessageTemplateContext is a validation file created by Post Office's validation library Vindicated. It will be included when you create your message template. You can find out more about vindicated here: https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/vindicated-validation-library/#vindicated:-post-office's-runtime-type-validation-library
import { type MessageTemplateContext } from '../../..';
import { LoomAiMeetingNotesBanner } from './ui/loom-ai-meeting-notes-banner';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';

// Currently we won't look into the message backend, but this is where you can add stages which
// change your message before it gets sent to the frontend.
export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

type MessageFrontendProps = MessageTemplateContext & {
	/**
	 * This function needs to be called in order to display the next message inside the confluence-side-nav placement
	 *
	 * See `integrated-teams/growth/placement-v2/src/confluence-side-nav/index.tsx`
	 */
	onSideNavClick: (nextBestActionType: NextBestAction) => string | void | null;

	onCallback: (callbackKey: NextBestAction) => Promise<void>;
};

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ onSideNavClick, onCallback }: MessageFrontendProps) => {
			return <LoomAiMeetingNotesBanner onSideNavClick={onSideNavClick} onCallback={onCallback} />;
		},
	},
});
